import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Card as BootstrapCard } from "react-bootstrap";

import Card from "../../Card";
import "./styles.scss";

const Tile = ({
  title,
  disabled,
  onClick,
  classes,
  rounded,
  children,
  dashboard,
}) => (
  <Card
    rounded={rounded}
    className={classNames(
      "mydpd-tile",
      disabled && "disabled",
      classes.container,
      dashboard && "mydpd-tile-dashboard"
    )}
    onClick={!disabled ? onClick : undefined}
  >
    <Card.Body className={classes.body}>{children}</Card.Body>
    <BootstrapCard.Footer
      className={classNames("mydpd-tile-footer", classes.footer)}
    >
      <Card.Text className={classes.footerText}>{title}</Card.Text>
    </BootstrapCard.Footer>
  </Card>
);

Tile.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    container: PropTypes.string,
    body: PropTypes.string,
    footer: PropTypes.string,
    footerText: PropTypes.string,
  }),
  rounded: PropTypes.bool,
  children: PropTypes.node,
  dashboard: PropTypes.bool,
};

Tile.defaultProps = {
  onClick: () => null,
  classes: {},
  rounded: true,
  dashboard: false,
};

export default Tile;
